var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"1200px","height":"500px"},attrs:{"id":"chart-organigram"}})
}
var staticRenderFns = []

export { render, staticRenderFns }